/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_TitleInputs */

const en_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use What You Have`)
};

const es_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa lo que ya tienes`)
};

const de_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzen Sie, was Sie haben`)
};

const zh_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`善用你已有的能力`)
};

const ar_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم ما لديك`)
};

const fr_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez ce que vous avez`)
};

const vi_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng những gì bạn đã có`)
};

const sw_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumia Ulicho Nacho`)
};

const th_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้สิ่งที่คุณมีอยู่`)
};

const bs_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koristi ono što već imaš`)
};

const ja_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持っているものを活かす`)
};

const ko_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가진 것을 활용하기`)
};

const pt_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o que você tem`)
};

const it_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa quello che hai`)
};

const sv_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Använd det du har`)
};

const nl_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik wat je hebt`)
};

const da_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brug det, du har`)
};

const nb_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruk det du har`)
};

const fi_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytä mitä sinulla on`)
};

const pl_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykorzystaj to, co masz`)
};

const ru_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте то, что у вас есть`)
};

const tr_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elinde olanı kullan`)
};

const hi_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जो आपके पास है, उसका उपयोग करें`)
};

const id_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan Apa yang Anda Miliki`)
};

const ms_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan Apa yang Anda Ada`)
};

const cs_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Využijte, co máte`)
};

const el_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χρησιμοποιήστε ό,τι έχετε`)
};

const he_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השתמשו במה שיש לכם`)
};

const af_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik wat jy het`)
};

const hu_method_content_step_02_title = /** @type {(inputs: Method_Content_Step_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Használd, amid van`)
};

/**
* | output |
* | --- |
* | "Use What You Have" |
*
* @param {Method_Content_Step_02_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_title = /** @type {((inputs?: Method_Content_Step_02_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_title(inputs)
	if (locale === "de") return de_method_content_step_02_title(inputs)
	if (locale === "zh") return zh_method_content_step_02_title(inputs)
	if (locale === "ar") return ar_method_content_step_02_title(inputs)
	if (locale === "fr") return fr_method_content_step_02_title(inputs)
	if (locale === "vi") return vi_method_content_step_02_title(inputs)
	if (locale === "sw") return sw_method_content_step_02_title(inputs)
	if (locale === "th") return th_method_content_step_02_title(inputs)
	if (locale === "bs") return bs_method_content_step_02_title(inputs)
	if (locale === "ja") return ja_method_content_step_02_title(inputs)
	if (locale === "ko") return ko_method_content_step_02_title(inputs)
	if (locale === "pt") return pt_method_content_step_02_title(inputs)
	if (locale === "it") return it_method_content_step_02_title(inputs)
	if (locale === "sv") return sv_method_content_step_02_title(inputs)
	if (locale === "nl") return nl_method_content_step_02_title(inputs)
	if (locale === "da") return da_method_content_step_02_title(inputs)
	if (locale === "nb") return nb_method_content_step_02_title(inputs)
	if (locale === "fi") return fi_method_content_step_02_title(inputs)
	if (locale === "pl") return pl_method_content_step_02_title(inputs)
	if (locale === "ru") return ru_method_content_step_02_title(inputs)
	if (locale === "tr") return tr_method_content_step_02_title(inputs)
	if (locale === "hi") return hi_method_content_step_02_title(inputs)
	if (locale === "id") return id_method_content_step_02_title(inputs)
	if (locale === "ms") return ms_method_content_step_02_title(inputs)
	if (locale === "cs") return cs_method_content_step_02_title(inputs)
	if (locale === "el") return el_method_content_step_02_title(inputs)
	if (locale === "he") return he_method_content_step_02_title(inputs)
	if (locale === "af") return af_method_content_step_02_title(inputs)
	if (locale === "hu") return hu_method_content_step_02_title(inputs)
	return en_method_content_step_02_title(inputs)
});